<template>
  <!--srcviewscompanylistriskvuehtmlStart-->
  <div>
    <div
      id="defaultId1"
      class="uedbd2"
      style="display: flex; height: 100%; background: #f5f5f5"
    >
      <div
        style="overflow: hidden; transition: all 0.2s ease 0s; flex: 0 0 auto"
        :class="$store.state.app.isMenu ? '' : 'hidemenu'"
        v-loading="RiskLoding"
      >
        <div style="height: 99%; padding-bottom: 11%">
          <div :class="!this.Compare ? '' : 'vague'" style="height: 98%">
            <div class="left_menu margin-top30" style="height: 98%">
              <div class="FilterQuestion">
                <div class="left_menu_question">
                  <div class="table">
                    <div class="left_menu_context">
                      <p class="left_menu_context-title">
                        Transaction Year
                        <span class="Clear_all" @click="clearAllTags"
                          ><i
                            class="iconfont icon-qingchu"
                            style="color: #ff6a6a; margin-right: 5px"
                          ></i
                          >Clear All</span
                        >
                      </p>

                      <el-select
                        clearable
                        filterable
                        @change="getCompanylsit"
                        v-model="impYearDate"
                        :popper-append-to-body="false"
                        style="width: 100%"
                        placeholder=" Transaction Year "
                      >
                        <el-option
                          v-for="item in impYearList"
                          :key="item"
                          :label="item"
                          :value="item"
                        >
                        </el-option>
                      </el-select>
                    </div>

                    <div class="left_menu_context">
                      <p class="left_menu_context-title">Country</p>

                      <el-select
                        filterable
                        v-model="countryCode"
                        clearable
                        @change="getCompanylsit"
                        :popper-append-to-body="false"
                        style="width: 100%"
                        placeholder="Select Country"
                        class="search-select-con"
                      >
                        <el-option
                          v-for="item in CountryList"
                          :key="item.countryCode"
                          :label="item.country"
                          :value="item.countryCode"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="cc5f49"
        :class="
          $store.state.app.isMenu
            ? 'scrollbar scrollbar_right'
            : ' scrollbar scrollbar_right udb507two'
        "
      >
        <div style="height: 100%" v-loading="RiskLoding">
          <div class="list-label" v-show="!Compare" style="height: 100%">
            <div
              id="c6d65e"
              class="trade_bottom_right_top Alchecked flex_center_bettwen"
              style="padding-left: 20px; align-items: center"
            >
              <div>
                <el-checkbox
                  v-if="isOpenSlct"
                  style="margin-right: 20px"
                  id="c0b733"
                  v-model="checked"
                  label
                  @change="changeSlctAll"
                  >All</el-checkbox
                >
              </div>
            </div>
            <div class="flex_center margin-bottom20">
              <ul class="flex_center Data-Management-ul">
                <li
                  v-for="(item, index) in managementMenu"
                  @click="MenuClick(item)"
                  :class="
                    menuActive == item.value
                      ? 'menuActiveColor font18 font_bold'
                      : 'font18'
                  "
                  :key="index"
                >
                  {{ item.label }}
                </li>
              </ul>
            </div>
            <h3 class="topTitle_content">
              <span class="topTitle font1A2332 font_bold" v-if="menuActive == 1"
                >List of Origin Information
              </span>
              <span class="topTitle font1A2332 font_bold" v-else
                >List of Destination Information
              </span>
            </h3>
            <div
              class="flex_center_between_box"
              style="width: 100%; height: 98%"
            >
              <div class="risk-center-list">
                <div>
                  <ul>
                    <draggable
                      filter=".forbid"
                      v-model="CompanyList"
                      :disabled="disabled"
                      animation="300"
                      :move="onMove"
                    >
                      <transition-group>
                        <li
                          v-for="(item, index) in CompanyList"
                          :key="index"
                          class="conpany-center-list forbid item"
                          :class="{
                            iconbgActiveBG: NationalIndustryActive == index,
                          }"
                        >
                          <div
                            class="flex_between_box"
                            style="align-items: center"
                          >
                            <div
                              class="conpany-center-list-left"
                              :class="
                                NationalIndustryShow
                                  ? 'conpany-center-list-leftWith'
                                  : 'conpany-center-list-left'
                              "
                            >
                              <el-checkbox
                                v-if="isOpenSlct"
                                id="cee084"
                                style="margin-right: 10px; margin-top: 0.3rem"
                                v-model="item.isChecked"
                                label
                                @change="changeItemChecked"
                              >
                              </el-checkbox>
                              <span
                                :class="
                                  item.isDing
                                    ? 'indexPositon'
                                    : 'indexPositonactive'
                                "
                                >{{ index + 1 }}</span
                              >
                              <div
                                :class="{
                                  detailcontent1:
                                    NationalIndustryShow &&
                                    NationalIndustryActive == index,
                                  detailcontent: !(
                                    NationalIndustryShow &&
                                    NationalIndustryActive == index
                                  ),
                                }"
                              >
                                <p class="flex_center_start">
                                  <img class="contry_img" :src="item.flag" />
                                  <span
                                    class="font_bold cuspoint CountryActive"
                                    @click="setNews(item)"
                                    >{{ item.countryName }}</span
                                  >
                                  <span v-if="item.yearOnYearGrowthRate">
                                    <span
                                      class="contentLeft10"
                                      v-if="item.yearOnYearGrowthRate != 0"
                                    >
                                      <svg
                                        t="1765261808549"
                                        style="transform: rotate(180deg)"
                                        v-if="item.yearOnYearGrowthRate < 0"
                                        class="icon"
                                        viewBox="0 0 1024 1024"
                                        version="1.1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        p-id="12147"
                                        width="20"
                                        height="20"
                                      >
                                        <path
                                          d="M512.687 84.864l-261.28 348.26h170.341v509.164h181.866v-509.164h170.341l-261.265-348.26zM512.687 84.864z"
                                          fill="#009EA7"
                                          p-id="12148"
                                        ></path>
                                      </svg>
                                      <svg
                                        t="1765261808549"
                                        v-else
                                        class="icon"
                                        viewBox="0 0 1024 1024"
                                        version="1.1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        p-id="12147"
                                        width="20"
                                        height="20"
                                      >
                                        <path
                                          d="M512.687 84.864l-261.28 348.26h170.341v509.164h181.866v-509.164h170.341l-261.265-348.26zM512.687 84.864z"
                                          fill="#FF6A6A"
                                          p-id="12148"
                                        ></path>
                                      </svg>
                                    </span>
                                    <span v-if="item.yearOnYearGrowthRate != 0">
                                      <span
                                        v-if="item.yearOnYearGrowthRate > 0"
                                        class="font18 flex_center"
                                        style="color: #ff6a6a; margin-left: 5px"
                                        >+{{ item.yearOnYearGrowthRate }}%</span
                                      >
                                      <span
                                        v-else
                                        class="font18 flex_center"
                                        style="color: #009ea7; margin-left: 5px"
                                        >-{{ item.yearOnYearGrowthRate }}%</span
                                      >
                                    </span>
                                  </span>
                                </p>

                                <p class="list-text-color">
                                  <span
                                    :class="{
                                      overexperise: NationalIndustryShow,
                                    }"
                                    style="min-width: 100%"
                                  >
                                    <span class="font666666"> ISO Code:</span>
                                    <span> {{ item.isoCode }}</span>
                                    <span class="fontDDDDDD contentLeft10"
                                      >|</span
                                    >
                                    <span class="contentLeft10 font666666"
                                      >Currency:
                                    </span>
                                    <span>{{ item.currency }} </span>
                                  </span>
                                </p>
                                <p class="list-text-color">
                                  <span
                                    :class="{
                                      overexperise: NationalIndustryShow,
                                    }"
                                    style="min-width: 100%"
                                  >
                                    <span class="font666666">
                                      Transaction Year:</span
                                    >
                                    <span>
                                      {{ item.latestTransactionDate }}</span
                                    >
                                    <span class="fontDDDDDD margin-left10"
                                      >|</span
                                    >
                                    <span class="margin-left10 font666666">
                                      Total export amount:</span
                                    >
                                    <span>
                                      {{
                                        item.totalExportAmount | FilterNum
                                      }}</span
                                    >
                                    <span class="fontDDDDDD margin-left10"
                                      >|</span
                                    >
                                    <span
                                      class="margin-left10 font666666"
                                      v-if="
                                        // !NationalIndustryShow
                                        true
                                      "
                                    >
                                      Export frequency:
                                    </span>
                                    <span
                                      v-if="
                                        // !NationalIndustryShow
                                        true
                                      "
                                      >{{
                                        item.exportFrequency | FilterNum
                                      }}</span
                                    >
                                  </span>
                                </p>
                              </div>
                            </div>
                            <div class="conpany-center-list-right">
                              <p>
                                <el-popover
                                  placement="top"
                                  trigger="hover"
                                  popper-class="table_popover"
                                  content="Shipping Overview"
                                >
                                  <button
                                    slot="reference"
                                    class="margin-left20 iconbg flex_center"
                                  >
                                    <i
                                      @click="exportCompanyImport(item)"
                                      class="iconfont icon-yunshu"
                                      style="color: #009ea7"
                                    ></i>
                                  </button>
                                </el-popover>

                                <el-popover
                                  placement="top"
                                  trigger="hover"
                                  popper-class="table_popover"
                                  content="Trade History and Trends"
                                >
                                  <span
                                    slot="reference"
                                    class="margin-left20 iconbg flex_center"
                                    :class="{
                                      iconbgActive:
                                        NationalIndustryActive == index,
                                    }"
                                  >
                                    <i
                                      v-if="NationalIndustryActive == index"
                                      @click="NationalIndustry(item, index)"
                                      class="iconfont icon-qushi"
                                      style="color: #ffffff"
                                    ></i>
                                    <i
                                      v-else
                                      @click="NationalIndustry(item, index)"
                                      class="iconfont icon-qushi"
                                      style="color: #009ea7"
                                    ></i>
                                  </span>
                                </el-popover>
                              </p>
                            </div>
                          </div>
                        </li>
                      </transition-group>
                    </draggable>
                  </ul>
                  <div
                    class="ShowAll flex_center font18 margin-top20"
                    v-if="page.pageSize < page.total"
                    @click="ShowAll"
                  >
                    Show All
                  </div>
                  <div
                    :class="{
                      marginbottom500: NationalIndustryShow,
                    }"
                  ></div>
                </div>
                <div
                  class="risk-right"
                  v-if="NationalIndustryShow"
                  :style="{ marginTop: calculateMarginTop() + 'px' }"
                >
                  <div
                    class="flex_center_between_box"
                    style="margin-bottom: 20px"
                  >
                    <p style="font-family: Arial Bold; margin-bottom: 0px">
                      Trade History and Trends
                    </p>
                    <div class="flex_center">
                      <svg
                        t="1733120402127"
                        @click="rifghtUpdate()"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="14841"
                        width="1.5714285714285714rem"
                        height="1.5714285714285714rem"
                      >
                        <path
                          d="M547.4 512l278.2-278.2c9.8-9.8 9.8-25.6 0-35.4-9.8-9.8-25.6-9.8-35.4 0L512 476.6 233.8 198.4c-9.8-9.8-25.6-9.8-35.4 0-9.8 9.8-9.8 25.6 0 35.4L476.6 512 198.4 790.2c-9.8 9.8-9.8 25.6 0 35.4 4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3L512 547.4l278.2 278.2c4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3c9.8-9.8 9.8-25.6 0-35.4L547.4 512z"
                          fill="#1A2332"
                          p-id="14842"
                        ></path>
                      </svg>
                    </div>
                  </div>
                  <el-date-picker
                    v-model="datePicker"
                    class="trade_date_picker"
                    type="monthrange"
                    range-separator=""
                    start-placeholder="Start date"
                    value-format="yyyy-MM"
                    end-placeholder="End date"
                    @change="getgetTradeTrends"
                  ></el-date-picker>
                  <div class="margin-top30">
                    <div
                      ref="SupplyChainEchart"
                      style="width: 100%; height: 33rem"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Login :loginAndCreatePop.sync="loginDialog"></Login>
    <SupplyChainList
      :ContactObj="ContactInfo"
      :IsCountry="true"
      :suoClose="SupplyChain"
      @clossuoDialogtwo="clossuoDialogtwo($event)"
    ></SupplyChainList>
  </div>
  <!--srcviewscompanylistriskvuehtmlEnd-->
</template>
<script>
// interfaceCode
//importStart
import draggable from "vuedraggable";

import { findPartnerDetail } from "@/api/searchApi.js";
import ContactInformation from "../ContactInformation.vue";
import SupplyChainList from "../SupplyChainList.vue";
import {
  getTradeTrends,
  getOriginOrDestinationList,
  getOriginOrDestinationListFilter,
} from "@/api/companyApi.js";

import Login from "@/components/login.vue";

import {
  getsearchExport,
  getHuokePartPrivilege,
  searchMoreEmail,
} from "@/api/companyApi.js";
import { mixins1 } from "@/mixins/index";
export default {
  name: "",
  props: {},
  watch: {},

  mixins: [mixins1],
  components: {
    draggable,
    Login,
    ContactInformation,
    SupplyChainList,
  },

  data() {
    return {
      PCMoudele: [],
      LastUpdate: "",
      ContactIn: false,
      SupplyChain: false,
      datePicker: ["2025-01", "2025-12"],
      loginDialog: false,
      Compare: false,
      supplierNamevalue: "",
      supplierNameList: [],
      Improtradio: "",
      buyerNameList: [],
      ContactInfo: {
        aaa_id: "",
        web_site: "",
        company_country: "",
      },
      buyerNamevalue: "",
      isShowTooltip: false,
      RiskLoding: false,
      MainProductsShow: "",
      json_fields: {
        companyTag: "companyTag",
        department: "department",
        email: "email",
        name: "name",
        phone: "phone",
        position: "position",
        linkedin: "linkedin",
      },
      json_fieldsImport: {
        Date: "ie_date",
        Products: "hscode_description_inter",
        "Buyer Names": "import_name",
        Destination: "import_country_inter",
        "Supplier Names": "export_name",
        Origin: "export_country_inter",
        Amount: "amount",
      },
      menuActive: 1,
      importGrowthRateTrendList: [],
      importTrendListEcharts: [],
      managementMenu: [
        {
          label: "Origin",
          value: "1",
        },
        {
          label: "Destination",
          value: "2",
        },
      ],

      compareList: [],
      totle: 0,
      checked: "",
      pageNo: 1,
      disabled: false,
      NationalIndustryActive: "null",
      isRotated: false,

      NationalIndustryShow: false,

      isOpenSlct: false,

      checkList: [],
      aaaid: "",

      CompanyList: [],
      parentTable: [],
      token: localStorage.getItem("token"),
      Saved: undefined,
      isChecked: "",
      DetailsFormImportlist: [],
      riskTotal: "",
      QuestionPageList: [],

      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      chageItIndex: 0,
      chageItTrue: false,
      CountryList: [],
      countryCode: "",
      impYearList: [],
      impYearDate: "",
    };
  },
  methods: {
    ShowAll() {
      this.page.pageSize = this.page.pageSize + 10;
      this.getSearchList();
    },
    clearAllTags() {
      this.impYearDate = "";
      this.countryCode = "";
      this.menuActive = 1;
      this.getCompanylsit();
    },
    getCompanylsit() {
      this.NationalIndustryShow = false;
      this.NationalIndustryActive = "null";
      this.page.pageSize = 10;
      this.getSearchList();
      this.getOriginOrDestinationListFilterList();
    },
    MenuClick(item) {
      this.NationalIndustryShow = false;
      this.NationalIndustryActive = null;
      this.page.pageSize = 10;
      this.impYearDate = "";
      this.countryCode = "";
      this.menuActive = item.value;
      this.getSearchList();
      this.getOriginOrDestinationListFilterList();
    },

    // 获取列表数据
    getSearchList(leadsPostFilter) {
      this.RiskLoding = true;
      getOriginOrDestinationList({
        hsCode: this.$route.query.id3a,
        transactionDate: this.impYearDate,
        countryCode: this.countryCode,
        type: this.menuActive,
        page: 1,
        pageSize: this.page.pageSize,
        aaaid: "",
      }).then((res) => {
        if (res.code == 200) {
          this.RiskLoding = false;
          this.page.total = res.data.total;
          let parentTable = res.data.rows;
          parentTable.map((item, index) => {
            let countryImg = this.getCountryImgUrl(item.countryCode);
            if (countryImg) {
              let flag = require("../../../../../static" + countryImg);
              parentTable[index].flag = flag;
              this.refresh++;
            }
          });
          this.CompanyList = parentTable;
        } else {
          this.RiskLoding = false;
          this.CompanyList = [];
        }
      });
    },
    getOriginOrDestinationListFilterList() {
      getOriginOrDestinationListFilter({
        countryCode: this.countryCode,
        transactionDate: this.impYearDate,
        aaaid: "",
        type: this.menuActive,
        hsCode: this.$route.query.id3a,
      }).then((res) => {
        if (res.code == 200) {
          this.impYearList = res.data.impYear;
          this.CountryList = res.data.countryInfos;
        }
      });
    },
    clossuoDialog(value) {
      this.ContactIn = value;
    },
    clossuoDialogtwo(value) {
      console.log(`value`, value);
      this.SupplyChain = value;
    },
    suppleEchart() {
      let that = this;

      this.echartsBox = this.$echarts.init(this.$refs.SupplyChainEchart);

      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
        },
        grid: {
          left: "0%", // 设置左侧边距
          right: "0%",
          top: "15%",
          bottom: "0%",
          containLabel: true,
        },
        legend: {
          left: "0px",
          top: "0px",
          //  width: '200px'
          // 其他图例配置项
          // ...
        },
        xAxis: {
          type: "category",
          data: that.importTrendListEcharts.map((item) => item.impYearMonth),
          axisTick: {
            show: false, // 不显示 x 轴上的间隔点
          },
          axisLabel: {
            rotate: -60, // 旋转角度设置为 45 度
          },
        },
        yAxis: [
          {
            type: "value",
            splitNumber: 4,
            // inverse: true,
            axisLine: {
              show: true,
              // 横坐标轴颜色
              lineStyle: {
                width: 1,

                color: "#8497AB",
              },
            },

            // 背景虚线
            splitLine: {
              lineStyle: {
                width: 1,
                type: "dashed",
                color: "#8398BB",
              },
            },
            axisLabel: {
              show: true,
              color: "#1A2332", // 设置字体颜色
              fontSize: 14, // 可以在这里设置字体大小
              fontWeight: "normal", // 字体粗细
              fontFamily: "Arial, Arial", // 字体类型,
              formatter: function (value) {
                return value.toLocaleString(); // 格式化为千分位
              },
            },
          },

          {
            type: "value",
            position: "right",
            alignTicks: true,
            axisLine: {
              show: true,
              // 横坐标轴颜色
              lineStyle: {
                width: 1,

                color: "#8398BB",
              },
            },
            // max:  that.ExporttableData.reduce((max, item) => (item.transactions > max ? item.transactions : max),  that.ExporttableData[0].transactions),
            axisLabel: {
              show: true,
              color: "#1A2332", // 设置字体颜色
              fontSize: 14, // 可以在这里设置字体大小
              fontWeight: "normal", // 字体粗细
              fontFamily: "Arial, Arial", // 字体类型,
              formatter: function (value) {
                return value.toLocaleString() + "%"; // 格式化为千分位
              },
              color: "#FF7600", // 这里设置颜色，比如红色
            },
          },
        ],
        series: [
          {
            name: "Trade Volume",
            type: "bar",
            barWidth: "20",
            itemStyle: { color: "#009EA7" },
            emphasis: {
              itemStyle: {
                color: "#009EA7",
              },
            },
            tooltip: {
              valueFormatter: function (value) {
                if (value != null) {
                  return "USD " + value.toLocaleString();
                } else {
                  return "-";
                }
              },
            },
            data: that.importTrendListEcharts.map((item) => item.amount),
          },
          {
            name: "Month on Month Ratio",
            type: "line",
            yAxisIndex: 1,
            itemStyle: { color: "#FF7600" },
            emphasis: {
              itemStyle: {
                color: "#FF7600",
              },
            },
            tooltip: {
              valueFormatter: function (value) {
                if (value != null) {
                  return value + "%";
                } else {
                  return "-";
                }
              },
            },
            data: that.importTrendListEcharts.map((item) => item.growthRate),
          },
        ],
      };
      this.echartsBox.setOption(option);
      this.$nextTick(() => {
        this.echartsBox.resize();
      });
    },

    calculateMarginTop() {
      if (
        this.NationalIndustryActive === "null" ||
        this.NationalIndustryActive === null
      ) {
        return 0;
      }
      // 使用 Vue 的 refs 来获取元素（如果可能的话）
      const listContainer = document.querySelector(".risk-center-list ul");
      const listItems = document.querySelectorAll(".conpany-center-list");

      if (
        listItems.length > 0 &&
        this.NationalIndustryActive < listItems.length
      ) {
        const targetItem = listItems[this.NationalIndustryActive];

        if (targetItem && listContainer) {
          // 计算目标元素相对于列表容器的偏移量
          const containerRect = listContainer.getBoundingClientRect();
          const itemRect = targetItem.getBoundingClientRect();

          // 返回相对于容器顶部的偏移量
          return itemRect.top - containerRect.top;
        }
      }

      // 如果在 nextTick 之外执行，返回默认值
      // 实际的计算将在 nextTick 中完成
    },

    NationalIndustry(item, index) {
      this.chageItTrue = true;
      this.NationalIndustryShow = true;
      this.NationalIndustryActive = index;
      this.aaaid = item.countryCode;
      this.datePicker = item.yearMonthList;
      this.$nextTick(() => {
        this.getgetTradeTrends();
        // 强制重新计算样式
        this.$forceUpdate();
      });
    },
    getgetTradeTrends() {
      getTradeTrends({
        startMonth: this.datePicker[0],
        type: this.menuActive,
        endMonth: this.datePicker[1],
        countryCodeFilter: this.aaaid,
        hsCode: this.$route.query.id3a,
      }).then((res) => {
        if (res.code == 200) {
          this.importTrendListEcharts = res.data;

          this.$nextTick(() => {
            this.suppleEchart();
          });
        }
      });
    },
    rifghtUpdate() {
      this.NationalIndustryShow = false;
      this.NationalIndustryActive = "null";
    },
    // echarts监听 浏览器宽度改变 echarts改变

    // 获取权限
    getHuokePartPrivilegeList() {
      getHuokePartPrivilege({
        moduleType: 7,
      }).then((res) => {
        if (res.code == 200) {
          this.PCMoudele = res.data;
        }
      });
    },

    // web导出
    exportCompanyWeb(item) {
      this.ContactIn = true;
      this.ContactInfo.aaa_id = "";

      this.ContactInfo.web_site = "";

      this.ContactInfo.company_country = item.countryCode;
    },
    DetailsFormConcat() {
      this.chageItTrue = true;
      if (this.PCMoudele[15].hasPrivilege) {
        let params = {
          page: 1,
          pageSize: 100,
          id3a: this.aaaId,
          website: this.itemList.web_site,
          countryCode: this.itemList.company_country,
        };
        //    return   this.DetailsFormImportlist
        return searchMoreEmail(params).then((res) => {
          if (res.code == 200) {
            if (res.data.contacts.length == 0) {
              this.$message({
                message: "No Data",
                type: "success",
              });
            } else {
              this.$message({
                message: res.msg,
                type: "success",
              });
            }
            return res.data.contacts;
          } else {
            return [];
          }
        });
      }
    },
    DetailsFormImport() {
      this.chageItTrue = true;
      if (this.PCMoudele[15].hasPrivilege) {
        return getsearchExport({
          page: 1,
          pageSize: 100,
          export_aaaid: this.aaaId,
          import_aaaid: this.aaaId,
        }).then((res) => {
          if (res.code == 200) {
            if (res.data.rows.length == 0) {
              this.$message({
                message: "No Data",
                type: "success",
              });
            } else {
              this.$message({
                message: res.msg,
                type: "success",
              });
            }
            return res.data.rows;
          } else {
            return [];
          }
        });
      }
    },
    // 贸易链路导出
    exportCompanyImport(item) {
      this.SupplyChain = true;
      this.ContactInfo.aaa_id = "";

      this.ContactInfo.web_site = "";

      this.ContactInfo.company_country = item.countryCode;
      // if (this.PCMoudele[15].hasPrivilege) {
      //     this.aaaId = item.aaa_id;
      // } else {
      //     this.$bus.$emit('show-permission-dialog', '您没有权限访问该功能！')
      // }
    },

    // 点击跳转
    setNews(row, detail) {
      this.$router.push({
        path: "Detail",
        query: {
          Moudles: this.$route.query.Moudles,
          idpower: this.$route.query.idpower,
          id3a: this.$route.query.id3a,
          SACode1: this.$route.query.SACode1,
          type: this.menuActive,
          countryCode: row.countryCode,
          currency: row.currency,
          isoCode: row.isoCode,
          totalExportAmount: row.totalExportAmount,
          latestTransactionDate: row.latestTransactionDate,
          exportFrequency: row.exportFrequency,
        },
      });
    },

    setToolsfalse() {
      this.$store.dispatch("app/setTools", {
        name: "select",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "sort",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "collect",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "saved",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "download",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "reportError",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "share",
        key: "isActive",
        value: false,
      });
    },
    // 工具栏高亮控制
    setToolsAcive() {
      this.$store.dispatch("app/setTools", {
        name: "Optimize",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "filter",
        key: "isActive",
        value: true,
      });
      this.$store.dispatch("app/setTools", {
        name: "menu",
        key: "isActive",
        value: true,
      });
      this.$store.dispatch("app/setTools", {
        name: "sort",
        key: "isActive",
        value: false && this.token,
      });
      this.$store.dispatch("app/setTools", {
        name: "select",
        key: "isActive",
        value: true && this.token,
      });
      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "collect",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "saved",
        key: "isActive",
        value: true,
      });
      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "download",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "reportError",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "share",
        key: "isActive",
        value: false,
      });

      //   this.$store.dispatch("app/setTools", "filter",'isActive',false);
    },
    // 收藏

    // 删除元素
    DelClick(item, index) {
      if (this.PCMoudele[13].hasPrivilege) {
        this.deledeLaeadsDialog = true;
      } else {
        this.$bus.$emit("show-permission-dialog", "您没有权限访问该功能！");
      }
    },

    // 移动
    onMove(e) {
      if (e.relatedContext.element.isDing == true) return false;
      return true;
    },

    // 全选操作
    changeItemChecked(value) {
      if (this.CompanyList.filter((item) => item.isChecked).length > 0) {
        this.checked = true;
      } else {
        this.checked = false;
      }

      let selectCompany = this.CompanyList.filter((item) => item.isChecked);
      this.$store.dispatch("app/setchangeList", selectCompany);
      this.compareList = selectCompany;
      // this.$nextTick(() => { });

      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "collect",
        key: "isActive",
        value: selectCompany.length > 0 && this.SavyeLeadsSuo == false,
      });
      this.$store.dispatch("app/setTools", {
        name: "saved",
        key: "isActive",
        value: true && this.Compare == false,
      });

      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: this.compareList.length > 0 && this.compareList.length < 4,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: selectCompany.length > 0,
      });

      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: selectCompany.length > 0,
      });

      this.$store.dispatch("app/setTools", {
        name: "download",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "reportError",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "share",
        key: "isActive",
        value: selectCompany.length > 0,
      });
    },
    // 全选操作
    changeSlctAll(value) {
      this.CompanyList.forEach((item) => {
        item.isChecked = value;
      });
      let selectCompany = this.CompanyList.filter((item) => item.isChecked);
      this.compareList = selectCompany;
      this.$store.dispatch("app/setchangeList", selectCompany);
    },
    cellClassName({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return "highlight-cell"; // 设置你想要的背景色
      }
    },

    // setTools
    setTools() {
      this.$store.dispatch("app/setTools", {
        name: "menu",
        key: "isActive",
        value: true,
      });

      this.$store.dispatch("app/setTools", {
        name: "select",
        key: "isActive",
        value: true,
      });

      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "sort",
        key: "isActive",
        value: false,
      });
    }, // getDetail
  },
  computed: {},
  created() {
    this.setToolsfalse();
  },
  mounted() {
    this.$emit("UpdatamarkTotalList", true);
    this.getSearchList();
    this.getOriginOrDestinationListFilterList();
    this.setToolsfalse();
    if (this.token) {
      this.getHuokePartPrivilegeList();
    }
  },
  beforeDestroy() {},
};
</script>
<style scoped>
.ud6279 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-top: 7.642857142857143rem;
}

.u96d4d {
  width: 29rem;
}

.uba4wV3 {
  margin-right: 1.0714285714285714rem;
  margin-bottom: 0.7142857142857143rem;
  margin-top: 0.7142857142857143rem;
  margin-left: 1.0714285714285714rem;
}

.trade_bottom_right_top {
  color: #999999;
  margin-bottom: 10px;
  font-size: 16px;
  text-align: left;
  font-style: normal;
  overflow: hidden;
}

.uVwoZks {
  width: 100%;
}

.hidemenu {
  display: block;
  width: 0em;
  padding-left: 0em;
  padding-top: 0em;
  padding-bottom: 0em;
  padding-right: 0em;
  box-sizing: border-box;
  overflow-y: hidden;
  overflow-x: hidden;
}

.scrollbar {
  overflow: hidden;
}

.udb507two {
  width: 100%;
}

.risk-right {
  width: 540px;
  padding: 20px;
  background: #ddedee;
  height: 694px;
  border-radius: 10px;
  position: absolute;
  top: 0px;
  right: 0px;
}

.risk-center-list {
  flex: 1;
  width: 49%;
  position: relative;
}

.Upadetime {
  font-size: 1.2857142857142858rem;
  color: #666666;
  margin-right: 2.142857142857143rem;
}

.flex_center_between_box p {
  font-size: 24px;
  color: #1a2332;
  min-height: 30px;
  margin-bottom: 10px;
  display: flex;
}

.risk-right-content {
  padding: 1.4285714285714286rem 0rem;
  border-top: 0.07142857142857142rem solid #cccccc;
}

.risk-right-content-title {
  font-size: 1.4285714285714286rem;
  color: #1a2332;
  height: 1.7142857142857142rem;
  margin-bottom: 1.4285714285714286rem;
  font-family: "Arial Bold";
}

.right-txt {
  text-align: right;
  font-size: 1.2857142857142858rem;
  color: #1a2332;
  line-height: 1.8571428571428572rem;
}

.left-txt {
  font-size: 1.2857142857142858rem;
  color: #666666;
}

.margin16 {
  margin-top: 1.1428571428571428rem;
}

.highlight-cell {
  background-color: #f2f5f9 !important;
}

.risk-right .el-table .cell {
  color: #1a2332;
}

.table-content {
  height: 3.5714285714285716rem !important;
  line-height: 3.5714285714285716rem;
}

.risk-right .el-table th.el-table__cell {
  background-color: #f2f5f9 !important;
}

.conpany-center-list {
  padding: 30px 20px 16px 20px;
  background: #f5f5f5;
  border-radius: 10px;
  margin-bottom: 10px;
  overflow-x: hidden;
}
.conpany-center-list.iconbgActiveBG {
  border-radius: 10px;
}
.conpany-center-list-left {
  font-size: 24px;
  color: #1a2332;
  display: flex;
  align-items: flex-start;
  /* width: auto; */
  width: 100%;
}

.conpany-center-list-leftWith {
  /* max-width: 75%; */
  max-width: calc(100% - 150px);
}

.conpany-center-list-right {
}

.risk-center-list .el-checkbox__inner,
.Alchecked .el-checkbox__inner {
  height: 1.4285714285714286rem !important;
  width: 1.4285714285714286rem !important;
}

.conpany-center-list-left .el-checkbox__inner {
  margin-top: 0.2857142857142857rem !important;
}

.risk-center-list .el-checkbox__inner::after,
.Alchecked .el-checkbox__inner::after {
  height: 0.7142857142857143rem;
  left: 0.5rem;
}

.risk-center-list .el-checkbox__input.is-checked .el-checkbox__inner,
.Alchecked .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #8e86dd;
  border-color: #8e86dd;
}

.risk-center-list .el-checkbox__input.is-focus .el-checkbox__inner,
.Alchecked .el-checkbox__input.is-focus .el-checkbox__inner,
.Alchecked
  .el-checkbox__inner:hover
  .risk-center-list
  .el-checkbox__inner:hover {
  border: 0.07142857142857142rem solid #dcdfe6;
}

.risk-center-list .el-checkbox__input.is-checked + .el-checkbox__label,
.Alchecked .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #1a2332;
}

.indexPositon {
  margin-right: 1.4285714285714286rem;
  color: #009ea7;
  width: 1.4285714285714286rem;
}

.indexPositonactive {
  margin-right: 10px;
  color: #999999;
  width: 30px;
  font-family: "Arial Bold";
  min-width: 30px;
}

.list-text-color {
  font-size: 18px !important;
  color: #666666 !important;
  display: flex;
  align-items: center;
}

.list-text-color span {
  color: #1a2332;
  margin-right: 10px;
}

.overexperise {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: fit-content;
}

.list-text-color img,
.contry_img {
  width: 36px;
  margin-right: 5px;
}

.iconbg {
  width: 50px;
  height: 50px;
  background: #ddedee;
  border-radius: 50%;
  cursor: pointer;
}

.conpany-center-list-right p {
  justify-content: flex-end;
  margin-bottom: 0px;
}

.bottom-list-echarts {
  padding-left: 2.8142857142857144rem;
  display: flex;
  justify-content: space-between;
}

.bottom-list-echarts-li {
  padding: 1.4285714285714286rem;
  background: #f5f5f5;
  height: 18.571428571428573rem;
  /* flex: 1; */
  width: 33%;
  padding-bottom: 0.7142857142857143rem;
}

.icontransform {
  display: inline-block;
  transition: transform 0.5s ease;
  /* 设置过渡效果 */
  cursor: pointer;
}

.rotate {
  transform: rotate(-180deg);
  /* 旋转180度 */
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active 在 Vue 2.x 中 */ {
  opacity: 0;
  /* 初始透明度 */
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
  /* 淡入淡出动画 */
}

.left_menu_title {
  font-size: 1.7142857142857142rem;
  color: #1a2332;
  margin: 1.4285714285714286rem 0rem;
  padding-bottom: 10px;
  border-bottom: 1px solid #dddddd;
  font-family: "Arial Bold";
}

.left_menu_question p {
  font-size: 18px;
  color: #1a2332;
  margin-bottom: 10px;
  font-family: "Arial Bold";
}

.left_menu_question .el-input__inner {
  height: 2.5714285714285716rem;
  background: #ffffff;
  border-radius: 0.2857142857142857rem;
  font-size: 1.1428571428571428rem;
  color: #1a2332;
  padding-left: 0.7142857142857143rem !important;
}

.left_menu_question /deep/ .el-select .el-input.is-focus .el-input__inner,
.left_menu_question /deep/ .el-select .el-input__inner:focus {
  border: 0.07142857142857142rem solid #cccccc !important;

  line-height: 2.428571rem !important;
}

.left_menu_question {
  margin-bottom: 10px;
  padding-bottom: 20px;
}

.FilterQuestion .left_menu_question {
  padding-bottom: 0rem;
}

/deep/ .el-input.is-disabled .el-input__inner {
  background-color: #f5f5f5;
  border-color: #cccccc;
  color: #999999;
  line-height: 2.428571rem !important;
}

.left_menu_bottom {
  font-size: 1.1428571428571428rem;
  color: #1a2332;
  margin-bottom: 3rem;
}

.profit-txt {
  width: 75%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.color1290C9 {
  text-align: right;
}

.question-detail_cont-list h3 {
  margin-top: 0.7142857142857143rem;
  font-family: "Arial";
  font-weight: 400;
  font-size: 1.2857142857142858rem;
  color: #1a2332;
}

button:disabled {
  cursor: no-drop !important;
}

.el-popover {
  padding: 10px !important;
  min-width: auto;
}

.uedbd2 {
  height: 100%;
}

.right_cont_box {
  height: 100%;
  overflow-y: auto;
}

.IElabel {
  font-size: 16px;
  color: #ff7600;
  text-align: center;
  background: #fff8f1;
  line-height: 26px;
  width: 70px;
  border-radius: 15px;
  border: 1px solid #ff7600;
}

.IElabelExport {
  background: #f4fbff;
  border-radius: 15px;
  border: 1px solid #1290c9;
  color: #1290c9;
}

.left_menu_context-title {
  font-size: 18px;
  color: #1a2332;
  font-family: "Arial Bold";
  margin-bottom: 20px;
  position: relative;
}

.left_menu_context {
  margin-bottom: 30px;
}
.trade_date_picker,
.left_menu_context /deep/ .el-input__inner {
  height: 36px !important;
  font-size: 16px;
}
.trade_date_picker {
  width: 300px;
}
/deep/ .el-radio {
  justify-content: flex-start;
  font-size: 1.1428575rem;
}

/deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #009ea7;
  font-size: 1.1428575rem;
}

/deep/ .el-radio__label {
  font-size: 1.1428575rem;
  color: #1a2332;
}

/deep/ .el-radio__input.is-checked .el-radio__inner {
  border-color: #009ea7;
  background: #fff;
}

/deep/ .el-radio__input.is-checked .el-radio__inner::after {
  background: #009ea7;
}

.Clear_all {
  position: absolute;
  right: 0px;
  font-size: 16px;
  z-index: 999;
  cursor: pointer;
}

.MainProducts {
  background: #f5f5f5;
  border-radius: 5px;
  border: 1px solid #009ea7;
  padding: 5px;
  margin-bottom: 5px;
  font-size: 16px;
  color: #009ea7;
  display: inline-block;
}

.MainProductsAll {
  width: 30px;
  height: 30px;
  background: #ddedee;
  border-radius: 50%;
  text-align: center;
  line-height: 20px;
  color: #009ea7;
  cursor: pointer;
}

.MainProductsMainProducts {
  width: 80%;
  height: 30px;
  overflow: hidden;
}

.iconbgActiveBG {
  background: #ddedee;
}

.iconbgActiveBG .iconbgActive {
  background: #009ea7;
}

.iconbgActiveBG {
  margin-right: 0px;
  border-radius: 5px 0px 0px 5px;
}

/deep/ .el-scrollbar__wrap {
  max-width: 21rem !important;
}
.icon-dianhuaheshi {
  font-size: 26px;
}
.icon-yunshu {
  font-size: 22px;
}
.icon-qushi {
  font-size: 28px;
}
.icon-shoucang {
  display: inline-block;
  font-size: 26px;
}
.icon-arrowup-copy,
.icon-arrowup {
  font-size: 20px;
  margin-right: 10px;
}
.contentLeft10 {
  margin-left: 10px;
}
.topTitle {
  font-size: 26px;
}
.marginbottom500 {
  margin-bottom: 500px;
}

.detailcontent {
  max-width: calc(100% - 40px);
}
.detailcontent1 {
  max-width: calc(100% - 400px);
}
@media (max-width: 1920px) {
  .left_menu_question p {
    font-size: 16px;
    margin-bottom: 10px;
  }
  .left_menu_question {
    margin-bottom: 7px;
    padding-bottom: 15px;
  }
  .left_menu_context {
    margin-bottom: 20px;
  }
  .Clear_all {
    font-size: 14px;
  }
  .trade_date_picker,
  .left_menu_context /deep/ .el-input__inner {
    height: 32px !important;
    font-size: 14px;
  }
  .trade_date_picker {
    width: 225px;
  }
  .trade_bottom_right_top {
    margin-bottom: 7px;
    font-size: 14px;
  }
  .conpany-center-list {
    padding: 22px 15px 12px 15px;
    margin-bottom: 7px;
  }
  .flex_center_between_box p {
    font-size: 18px;
    min-height: 22px;
    margin-bottom: 7px;
  }
  .indexPositonactive {
    margin-right: 7px;
    width: 22px;
    min-width: 23px;
  }
  .conpany-center-list-left {
    font-size: 18px;
  }
  .icon-dianhuaheshi {
    font-size: 24px;
  }
  .icon-yunshu {
    font-size: 20px;
  }
  .icon-qushi {
    font-size: 26px;
  }
  .icon-shoucang {
    font-size: 20px;
  }
  .icon-arrowup-copy,
  .icon-arrowup {
    font-size: 16px;
    margin-right: 7px;
  }
  .list-text-color img,
  .contry_img {
    width: 27px;
    margin-right: 4px;
  }
  .list-text-color {
    font-size: 16px !important;
  }
  .list-text-color span {
    margin-right: 8px;
  }
  .iconbg {
    width: 37px;
    height: 37px;
  }
  .risk-right {
    width: 480px;
    padding: 15px;
    height: 633px;
  }
  .overexperise {
    max-width: 100%;
  }
  .contentLeft10 {
    margin-left: 8px;
  }
  .left_menu_context-title {
    font-size: 16px;
    margin-bottom: 7px;
  }
  .topTitle_content {
    margin-bottom: 25px;
  }
  .topTitle {
    font-size: 20px;
    line-height: 40px;
  }
}
@media screen and (max-width: 1439px) {
  .left_menu_question p {
    font-size: 14px;
    margin-bottom: 6px;
  }
  .left_menu_question {
    margin-bottom: 6px;
    padding-bottom: 13px;
  }
  .left_menu_context {
    margin-bottom: 20px;
  }
  .Clear_all {
    font-size: 12px;
  }
  .trade_bottom_right_top {
    margin-bottom: 6px;
    font-size: 12px;
  }
  .conpany-center-list {
    padding: 20px 13px 10px 13px;
    margin-bottom: 6px;
  }
  .flex_center_between_box p {
    font-size: 16px;
    min-height: 20px;
    margin-bottom: 6px;
  }
  .indexPositonactive {
    margin-right: 6px;
    width: 20px;
    min-width: 20px;
  }
  .conpany-center-list-left {
    font-size: 16px;
  }
  .icon-dianhuaheshi {
    font-size: 24px;
  }
  .icon-yunshu {
    font-size: 20px;
  }
  .icon-qushi {
    font-size: 26px;
  }
  .icon-shoucang {
    font-size: 18px;
  }
  .icon-arrowup-copy,
  .icon-arrowup {
    font-size: 16px;
    margin-right: 6px;
  }
  .list-text-color img,
  .contry_img {
    width: 24px;
    margin-right: 3px;
  }
  .list-text-color {
    font-size: 14px !important;
  }
  .list-text-color span {
    margin-right: 7px;
  }
  .iconbg {
    width: 33px;
    height: 33px;
  }
  .risk-right {
    width: 500px;
    padding: 13px;
    height: 564px;
  }
  .overexperise {
    max-width: 100%;
  }
  .contentLeft10 {
    margin-left: 7px;
  }
  .left_menu_context-title {
    font-size: 14px;
    margin-bottom: 6px;
  }
  .topTitle {
    font-size: 18px;
  }
}
</style>
